import { type FC, type ReactElement } from 'react'

import { Experiment } from '../../../experiments/components/Experiment'
import { ExperimentVariant } from '../../../experiments/components/ExperimentVariant'
import { EXPERIMENT_NAME_ODS_VC_MODAL } from '../../../experiments/model/EXPERIMENT_NAME'
import { EXPERIMENT_VARIATION } from '../../../experiments/model/EXPERIMENT_VARIATION'

import { useProductPageOdsContext } from './productPageODSContext'

export const ExperimentOdsVideoConsultationWrapper: FC<{
  childVideoConsultationV1: ReactElement
  childZavaProvider: ReactElement
}> = ({ childVideoConsultationV1, childZavaProvider }) => {
  const { experimentOdsV1Enabled, videoConsultation } =
    useProductPageOdsContext()

  if (!videoConsultation) {
    return childZavaProvider
  }

  return (
    <Experiment names={[EXPERIMENT_NAME_ODS_VC_MODAL]}>
      <ExperimentVariant
        name={
          experimentOdsV1Enabled
            ? EXPERIMENT_VARIATION.V1
            : EXPERIMENT_VARIATION.DEFAULT
        }
      >
        {experimentOdsV1Enabled ? childVideoConsultationV1 : childZavaProvider}
      </ExperimentVariant>
    </Experiment>
  )
}
